var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#D94858"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1378_31128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1378_31128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4 20.5L16 17.9L18.6 20.5L20 19.1L17.4 16.5L20 13.9L18.6 12.5L16 15.1L13.4 12.5L12 13.9L14.6 16.5L12 19.1L13.4 20.5ZM11 25C10.45 25 9.97933 24.8043 9.588 24.413C9.196 24.021 9 23.55 9 23V10H8V8H13V7H19V8H24V10H23V23C23 23.55 22.8043 24.021 22.413 24.413C22.021 24.8043 21.55 25 21 25H11ZM21 10H11V23H21V10Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.579284a2c61d0f590b5cd50a6a409487.svg";
export { ForwardRef as ReactComponent };